import { create } from 'zustand';
import { persist } from 'zustand/middleware';

// Custom persist with expiry for localStorage
function persistWithExpiry(config, options) {
  return persist(
    (set, get) => ({
      ...config(set, get)
    }),
    {
      ...options,
      storage: {
        getItem: (name) => {
          const str = localStorage.getItem(name);
          if (!str) return null;
          try {
            const data = JSON.parse(str);
            // Check expiry (default: 24h)
            const expiryMs = data.expiryMs || 1000 * 60 * 60 * 24;
            if (data.timestamp && Date.now() - data.timestamp > expiryMs) {
              localStorage.removeItem(name);
              return null;
            }
            return data.state;
          } catch {
            return null;
          }
        },
        setItem: (name, value) => {
          // Save with timestamp and expiry (24h)
          localStorage.setItem(
            name,
            JSON.stringify({
              state: value,
              timestamp: Date.now(),
              expiryMs: 1000 * 60 * 60 * 24 // 24 hours
            })
          );
        },
        removeItem: (name) => localStorage.removeItem(name)
      },
      partialize: (state) => ({ filterData: state.filterData })
    }
  );
}

const useFilterStore = create(
  persistWithExpiry(
    (set) => ({
      propertyType: '',
      status: '',
      ageRange: { min: '', max: '' },
      diningOptions: {
        separateDiningRoom: false,
        eatInKitchen: false,
        islandSeating: false,
        breakfastNook: false
      },
      filterData: {},

      // Actions
      setPropertyType: (type) => set({ propertyType: type }),
      setStatus: (status) => set({ status }),
      setAgeRange: (range) => set({ ageRange: range }),
      toggleDiningOption: (key) =>
        set((state) => ({
          diningOptions: {
            ...state.diningOptions,
            [key]: !state.diningOptions[key]
          }
        })),
      storeFilterData: (formData) => set({ filterData: formData }), // Store the entire formData object in filterData

      // Optional: Reset all
      resetFilters: () =>
        set({
          propertyType: '',
          status: '',
          ageRange: { min: '', max: '' },
          diningOptions: {
            separateDiningRoom: false,
            eatInKitchen: false,
            islandSeating: false,
            breakfastNook: false
          },
          filterData: {} // Reset formData to initial state
        })
    }),
    {
      name: 'filter-storage' // unique name for sessionStorage
    }
  )
);

export default useFilterStore;
